/** WARNING: This file is generated automatically **/

import type { TrackingContextValue } from '../providers/TrackingContext';
import { getEntities } from '../utils/getEntities';
import { getGTMData } from '../utils/getGTMData';
import { trackSelfDescribingEvent } from '../utils/trackSelfDescribingEvent';

/**
 * Fires when a button is clicked
 */
export interface ButtonClick {
  /**
   * text within the button in english
   */
  buttonName: string;
}

export const buttonClick = (data: Readonly<ButtonClick>, context?: TrackingContextValue) => {
  window.__GTM_DATA_LAYER__?.push({ event: 'button_click', ...data, ...getGTMData(context) });

  trackSelfDescribingEvent(
    {
      event: {
        schema: 'iglu:com.starsgroup/button_click/jsonschema/1-0-0',
        data
      },
      context: getEntities(context)
    },
    context
  );
};
